<template>
    <div class="container-fluid px-0">
    	
        
        <br>
        <transition name="fade">
        <div class="container-fluid">
            <!-- <div class="row d-flex px-lg-5">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
                <h5 class="text-center">VALIDACIÓN DE DOCUMENTOS CON FIRMA ELECTRÓNICA</h5>
              </div>
            </div> -->
            <div class="row d-flex px-lg-5">
              <div class="col-12 col-sm-12 col-md-12 col-lg-2 padding-div-low" style="margin-top:0px;margin-bottom:0px;"></div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-8 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
                <div class="row align-items-center">
                    <div class="form-group col-3" id="Area_div">
                      <label>Código :</label>
                    </div>
                    <div class="form-group col-4" id="Area_div">
                      <input type="text" class="form-control" v-model="paramTofind" />
                    </div>
                    <div class="form-group col-4" id="Area_div">
                      <button class="btn btn-sm btn-dark" @click='buscarDatos(paramTofind)'>Buscar</button>
                    </div>
                  </div>
                  <div class="row align-items-center" v-if="this.info.Fecha!=undefined && this.info.Fecha!=''">
                    <div class="form-group col-3" id="Area_div">
                      <label>Fecha de Firmado:</label>
                    </div>
                    <div class="form-group col-4" id="Area_div">
                      <input type="text" class="form-control" v-model="info.Fecha" readonly />
                    </div>
                  </div>
                  <div class="row align-items-center" v-if="this.info.firmantes.length>0">
                    <div class="form-group col-12" id="Area_div">
                      <label>Firmantes:</label>
                      <ul v-for="item in info.firmantes" :key="item.id">
                        <template >
                          <li>{{item.signatoreName}}
                          </li>
                        </template>
                      </ul>
                    </div>
                  </div>
              </div>
              
            </div>
            <div class="row d-flex px-lg-5">
              
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low" style="margin-top:0px;margin-bottom:0px;" v-if="info.file!=null && info.file!=''" >
                <h3 class="text-center" >Vista previa del documento</h3>
                  <!-- <PDFdocument :EsBase64="{ esBase64: true, archivoBase64: info.file }"></PDFdocument>  -->
                  <object :data="info.file" type="application/pdf" width="100%" height="600px">
                      Tu navegador no soporta mostrar PDFs.
                    </object>
              </div>
              <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low" style="margin-top:0px;margin-bottom:0px;" v-if="info.file!=null && info.file!=''" ></div> -->
            </div>
        </div>
        </transition>
    </div>
</template>

<script>

import axios from 'axios'
import comun from '@/../static/js/comun'
import PDFdocument from '@/components/Comunes/PDFDocument.vue';
import api from '@/../static/js/api'

export default {
    components: {
      PDFdocument
    }, 
    data() {
      return {
        paramTofind : '',
        qr: String,
        info: {
          Fecha: '',
          firmantes: [],
          file: '',
        },
        url: 'http://10.0.200.102:8085/microConsultaPublicaAcuse/api/signed-document/v1/validate/get-document-info?qrCode='
      }
    },
    created(){
        this.qr=this.$route.query.CodigoQR
    },
    mounted() {
      if(this.qr!='' && this.qr!=undefined)
      {
        this.buscarDatos(this.qr)
      }
      
    },

    methods: {
      buscarDatos: function(qr)
      {
        comun.SeEstaCargandoInformacion(true);

        axios.get(this.url + qr)
          .then( respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if(respuesta.data.headersResponse.statusCode==200)
            {
              this.paramTofind = respuesta.data.data.codeQR,
              this.info.Fecha = moment(respuesta.data.data.signedDate).locale('es').format("DD/MM/YYYY HH:mm:ss");
              this.info.firmantes = respuesta.data.data.signatoreList;
              this.info.file = ('data:application/pdf;base64,' + respuesta.data.data.fileContent);
            }

          })
          .catch(excepcion => {
            comun.SeEstaCargandoInformacion(false);
            this.info.Fecha = '';
            this.info.firmantes = [],
            this.info.rutaArchivo = null
            console.log(excepcion);

            comun.mensajeDeAlerta("Error Interno del servidor o consulta no valida", null, null);
            
          })
      }
    }
}
</script>
<style scoped>
  .page-title {
    background-color: rgb(33,33,33);
    color: #FFF;
    padding: 2vh 20vw;
  }

  .div-principal-verificacionFirmas .alert-dark {
    color: black;
    background-color: #545757;
    border-color: #c6c8ca;
  }

  .alert-info-verificacionFirmas p > span {
    font-weight: 900;
    font-size: 1.3em;
  }
  input[type="text"]:read-only {
    background: #504f54;
  }

  input[type="text"]:read-only:focus {
    color: #fff;
  }


</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/Funciones/ValidaDocumentoFirmado/VistaValidaDocumentoFirmadoQR.vue